import React from 'react'
import { BreadcrumbNavigation } from '@renderer/components/BreadCrumbs'

export const BreadcrumbBar: React.FC = () => (
  <div className="relative z-10 flex items-center px-4 sm:px-6">
    <BreadcrumbNavigation />
  </div>
)
